import React from 'react';
import { RIARMABILI_TESTO } from '../pages/campagneData';

/* La barra delle azioni di massa della pagina Campagne.

   Due selezioni DIVERSE che l'utente deve poter distinguere: le righe spuntate a mano (o
   con la casella in testata, che prende quelle mostrate) e "tutte quelle che rispettano i
   filtri", che sono migliaia e non stanno a schermo. Percio' la barra dice SEMPRE su
   quante righe agira', e l'allargamento a tutte le filtrate si offre a parte, con un
   numero scritto.

   Qui dentro non si chiama nessun endpoint: la barra e' solo quello che si vede. Chi manda
   {ids} oppure {filtro} — mai tutt'e due — e' la pagina. */

const fmt = (n) => (n ?? 0).toLocaleString('it-IT');

// Le azioni, con la spiegazione di cosa toccano: il backend restringe sempre agli stati
// ammessi (restringi_stati), e dirlo prima evita il "ha risposto zero e non capisco".
export const AZIONI = [
  { key: 'accendi', label: 'Accendi l’indagine',
    titolo: 'Accende l’indagine sulle righe da indagare e su quelle non risolte.' },
  { key: 'spegni', label: 'Spegni l’indagine',
    titolo: 'Spegne l’indagine sulle righe da indagare e su quelle non risolte.' },
  { key: 'riindaga', label: 'Ri-indaga',
    titolo: 'Solo sulle non risolte: le rimette da indagare, perché un sito che non '
          + 'c’era sei mesi fa adesso può esserci.' },
  { key: 'riarma', label: 'Riarma',
    titolo: `Solo sulle ${RIARMABILI_TESTO}: tornano da indagare, con `
          + 'l’indagine accesa.' },
];

export default function CampagnaAzioni({
  selezionate, tuttiFiltrati, totale, mostrate, tuttaPagina,
  onTutteFiltrate, onSoloMostrate, onAnnulla, onAzione, azione,
}) {
  if (!tuttiFiltrati && !selezionate) return null;
  const bersaglio = tuttiFiltrati ? totale : selezionate;
  const occupato = !!azione;

  return (
    <div className="camp-azioni">
      {/* L'ambito, prima di tutto: quale delle due selezioni sto usando */}
      {tuttiFiltrati ? (
        <div className="camp-ambito">
          Selezionate <b>tutte le {fmt(totale)} righe</b> che rispettano i filtri.{' '}
          <button type="button" className="camp-azzera" onClick={onSoloMostrate}>
            Torna alle {fmt(mostrate)} mostrate
          </button>
        </div>
      ) : tuttaPagina && totale > mostrate ? (
        <div className="camp-ambito">
          Selezionate <b>{fmt(selezionate)} righe</b> (quelle mostrate).{' '}
          <button type="button" className="camp-azzera" onClick={onTutteFiltrate}>
            Seleziona tutte le {fmt(totale)} che rispettano i filtri
          </button>
        </div>
      ) : null}

      <div className="camp-azioni-riga">
        {/* "al massimo": ogni azione restringe poi agli stati che ammette (il backend lo
            fa con restringi_stati), quindi "Ri-indaga su 3.133" ne tocchera' solo le non
            risolte. Un secondo conteggio per azione sarebbe peggio del male. */}
        <span className="camp-bersaglio"
          title="Al massimo queste: ogni azione tocca solo le righe negli stati che ammette.">
          Agisco su al massimo <b>{fmt(bersaglio)}</b> righe
        </span>
        {AZIONI.map((a) => (
          <button key={a.key} type="button" className="btn btn-secondary camp-btn-mini"
            title={a.titolo} disabled={occupato} onClick={() => onAzione(a.key)}>
            {azione === a.key ? 'Lavoro…' : a.label}
          </button>
        ))}
        <div className="camp-spazio" />
        <button type="button" className="camp-azzera" onClick={onAnnulla} disabled={occupato}>
          Annulla la selezione
        </button>
      </div>
    </div>
  );
}
